import { css } from "@linaria/core";
import { units, fonts } from "@pm2/compat";

export const captionCls = css`
  --font-size: ${units.font.px(1.4 * 10)};
  --line-height: ${fonts.lineHeight(1.35)};

  padding-inline: ${units.px(1.5 * 10)};
  padding-top: ${units.px(1.5 * 10)};

  box-sizing: border-box;
  width: 100%;
  min-height: ${units.px(3.5 * 10)};

  display: block;
  text-align: center;

  font-family: ${fonts.body()};
  font-size: var(--font-size);
  font-style: italic;
  line-height: var(--line-height);

  &:empty {
    display: none;
  }
`;

export const contentCls = css`
  position: relative;
  z-index: 3;
`;

export const titleCls = css`
  font-weight: 700;
  font-style: normal;
`;

export const spanCls = css`
  display: inline;
`;
